import PropTypes from "prop-types";

/**
 * @typedef {Object} AIBotProps
 * @property {string} [projectId] - Dialogflow project ID
 * @property {string} [agentId] - Dialogflow agent ID
 * @property {string} [languageCode] - Language code
 * @property {string} [maxQueryLength] - Max query length
 * @property {string} [chatTitle] - Chat title
 * @property {string} [chatIcon] - Chat icon URL
 * @property {string} [disclaimerMessage] - Disclaimer text shown in welcome message
 * @property {string} [welcomeGreeting] - Welcome greeting text
 * @property {boolean} [isGated] - When true, component does not render
 * @property {string} [oauthClientId] - Google oauthClientId
 * @property {string} [accessTokenName] - When empty there's no auth given to google, otherwise it's auth
 */

export const aiBotPropTypes = {
  projectId: PropTypes.string,
  agentId: PropTypes.string,
  languageCode: PropTypes.string,
  maxQueryLength: PropTypes.string,
  chatTitle: PropTypes.string,
  chatIcon: PropTypes.string,
  disclaimerMessage: PropTypes.string,
  welcomeGreeting: PropTypes.string,
  isGated: PropTypes.bool,
  oauthClientId: PropTypes.string,
  accessTokenName: PropTypes.string,
};

